module.exports = __webpack_public_path__ + "static/img/组 2916.e41ca6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/auditing/images/组 2916.png
// module id = Edv0
// module chunks = 0